export default __webpack_public_path__ + "static/media/walmart.18ba5195.svg";